import * as React from 'react';
import { useEffect } from 'react';
import {
    Datagrid,
    DateField,
    DateTimeInput,
    FunctionField,
    List,
    ReferenceField,
    SelectArrayInput,
    TextField,
    TextInput,
    useRedirect,
    useRefresh,
} from 'react-admin';
import { useLocation } from 'react-router-dom';
import { getRequestStatusName } from '../enum-translates';
import { Chip } from '@material-ui/core';
import { getStatusColor } from '../common/status-history';
import { Button, Tooltip } from '@mui/material';
import { getJwtData } from '../auth/authProvider';
import { useTheme } from '@mui/material/styles';

export interface RequestListProps {
    title: string;
    type: string;
}

const requestFilters = [
    <TextInput source="query" label={'Név'} name={'query'} />,
    <SelectArrayInput
        source="status"
        label={'Státusz'}
        choices={[
            { id: 'Free', name: 'Foglalható' },
            { id: 'InProgress', name: 'Folyamatban' },
            { id: 'UnderDuty', name: 'Feldolgozás alatt' },
            { id: 'Closed', name: 'Lezárva' },
        ]}
        defaultValue={['Free']}
        key={2}
    />,
    <DateTimeInput
        source="dateFrom"
        name={'dateFrom'}
        label={'Dátum ettől'}
        key={3}
    />,
    <DateTimeInput
        source="dateTo"
        name={'dateTo'}
        label={'Dátum eddig'}
        key={4}
    />,
];

export const RequestList = (props: RequestListProps) => {
    const theme = useTheme();
    const path = useLocation();
    const user = getJwtData();
    const redirect = useRedirect();
    const refresh = useRefresh();

    useEffect(() => {
        const id = setInterval(() => {
            refresh();
        }, 5000);

        return () => clearInterval(id);
    }, []);

    return (
        <List
            title={props.title}
            filters={requestFilters}
            sort={{ field: 'createdAt', order: 'DESC' }}
        >
            <Datagrid bulkActionButtons={false}>
                {/*<TextField source="id" label={'ID'} sortable={false} />*/}
                <ReferenceField
                    source="userId"
                    reference="web-user"
                    link="show"
                    label={'Felhasználó'}
                    sortable={false}
                >
                    <TextField source="name" />
                </ReferenceField>
                {!path.pathname.includes('EInvoice') && (
                    <TextField
                        source="address"
                        label={'Cím'}
                        sortable={false}
                    />
                )}
                {path.pathname.includes('DebtFree') && (
                    <FunctionField
                        label="Státusz"
                        render={(record: any) => (
                            <Tooltip
                                placement={'top'}
                                title={
                                    record.user &&
                                    record.status &&
                                    record.status.admin?.name &&
                                    record.status.lastModified
                                        ? `${record.status.admin.name} -  ${record.status.lastModified.substring(0, 10)} ${record.status.lastModified.substring(11, 19)}`
                                        : ''
                                }
                                arrow
                            >
                                <Chip
                                    style={{
                                        backgroundColor: getStatusColor(
                                            theme,
                                            record.status.status
                                        ),
                                        color: '#FFF',
                                    }}
                                    label={getRequestStatusName(
                                        record.status.status
                                    )}
                                />
                            </Tooltip>
                        )}
                    />
                )}
                <DateField
                    source="createdAt"
                    locales={['hu-HU']}
                    label={'Létrehozva'}
                    showTime
                    sortable={false}
                />
                {path.pathname.includes('DebtFree') && (
                    <FunctionField
                        label=""
                        render={(record: any) => (
                            <Button
                                variant={'contained'}
                                disabled={
                                    record.status.status === 'InProgress' &&
                                    record.status.admin.id !== user.userId
                                }
                                onClick={async () => {
                                    redirect(
                                        'show',
                                        'request/_DebtFree',
                                        record.id
                                    );
                                }}
                            >
                                Szerkesztés
                            </Button>
                        )}
                    />
                )}
            </Datagrid>
        </List>
    );
};
